import Navbar from "@/components/feature/Navbar";
import Hero from "@/components/feature/Hero";
import FeatureStory from "@/components/feature/FeatureStory";
import StatsSection from "@/components/feature/StatsSection";
import NewsSection from "@/components/feature/NewsSection";
import DeclarationBanner from "@/components/feature/DeclarationBanner";
import RankingsSection from "@/components/feature/RankingsSection";
import PartnersMarquee from "@/components/feature/PartnersMarquee";
import Newsletter from "@/components/feature/Newsletter";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <FeatureStory />
        <StatsSection />
        <NewsSection />
        <DeclarationBanner />
        <RankingsSection />
        <PartnersMarquee />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}